import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';

import queryClient from '../query-client';
import { CWTSchema } from '../types/custom-worksheet-v2';

export type UpdateCWTSchemaParams = {
    schema: CWTSchema;
};

async function updateCWTSchema(templateId: string, req: UpdateCWTSchemaParams): Promise<{ results: [] }> {
    const { data } = await api.put(`/templates/custom-worksheets/${templateId}/schema`, { schema: req.schema });
    return data;
}

export function useUpdateCWTSchema(templateId: string): UseMutationResult<{ results: [] }, AxiosError, UpdateCWTSchemaParams, unknown> {
    return useMutation((req: UpdateCWTSchemaParams) => updateCWTSchema(templateId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['custom-worksheet-templates', templateId]);
        },
    });
}
